import Spinner from '@material-tailwind/react/components/Spinner'
import React from 'react'

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

export const Loader = ({ size = 'md' }: LoaderProps) => {
  const classes = getSizeClasses(size)
  return <Spinner className={classes} />
}

function getSizeClasses(size: LoaderProps['size']) {
  switch (size) {
    case 'sm':
      return 'w-5 h-5'
    case 'lg':
      return 'w-12 h-12'
    case 'xl':
      return 'w-16 h-16'
    case '2xl':
      return 'w-24 h-24'

    case 'md':
    default:
      return 'w-8 h-8'
  }
}
